import React from 'react';
import Helmet from 'react-helmet';

import './businessPage.scss';

export default function Template({data}) {
	const {markdownRemark: post} = data;
	return (
		<main className={'page-business'}>
			<Helmet title={`Merchants Partners - ${post.frontmatter.title}`}/>
			<div className={'wrapper'}>
				<h1 className={'section-title'}>{post.frontmatter.title}</h1>
				<div
					dangerouslySetInnerHTML={{__html: post.html}}
				/>
			</div>
		</main>

	);
}

export const pageQuery = graphql`
  query BusinessPageByPath($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        path
        title
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/templates/businessPage.jsx